import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'signup';

  public buttonClick(): void {
    alert('YES! YES! YES!')
  }
}
